import React from 'react';
import classNames from 'classnames';

import css from './ColorSwatch.module.css';

const MULTICOLOR = 'multicolor';

/**
 * A round color swatch. The swatch is decorative: show the color name next to it.
 *
 * @component
 * @param {Object} props
 * @param {string?} props.className add more style rules in addition to components own css.root
 * @param {string?} props.rootClassName overwrite components own css.root
 * @param {string} props.color css color (e.g. '#2f6dcc') or 'multicolor'
 * @param {('small' | 'medium' | 'large')} [props.size='medium']
 * @returns {JSX.Element} color swatch
 */
const ColorSwatch = props => {
  const { className, rootClassName, color, size = 'medium' } = props;
  const isMulticolor = color === MULTICOLOR;
  const classes = classNames(rootClassName || css.root, className, css[size], {
    [css.multicolor]: isMulticolor,
  });
  const styleMaybe = isMulticolor || !color ? {} : { style: { backgroundColor: color } };

  return <span className={classes} aria-hidden="true" {...styleMaybe} />;
};

export default ColorSwatch;
